import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import { Button } from "reactstrap";


import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,

  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { Badge, Form, Modal, ModalBody, ModalHeader, Spinner, Table } from "reactstrap";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import { toast } from "react-toastify";
import useLogout from "../../hooks/useLogout";
import { getBookingListAPI, getMedicineRequest } from "../../api/doctor";
import MyButton from "../../MyComp/UI/form/MyButton";
import MySelect from "../../MyComp/UI/form/MySelect";
import MyInput from "../../MyComp/UI/form/MyInput";
import { useNavigate } from "react-router";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import { BASE_URL_IMG } from "../../assets/constants";
import { ModalFooter } from "reactstrap";

// import {
//   UncontrolledDropdown,
//   DropdownToggle,
//   DropdownMenu,
//   DropdownItem
// } from "reactstrap";


const RequestMedicine = ({ toggle, onConfirm, status, isPub }) => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
    },
  });
  const [viewModal, setViewModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleView = (row) => {
    setSelectedRow(row);
    setViewModal(true);
  };
  const [isOpen, setIsOpen] = useState(false);
  const logout = useLogout();
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);
  const navigate = useNavigate()
  const [imageOpen, setImageOpen] = useState(false);

  // const handleImageOpenPreview = (row) => {
  //   const imageUrl = `${BASE_URL_IMG}${row?.image}`;
  //   setValue("image_preview", imageUrl);
  //   setImageOpen(true);
  // };

  const [prescriptionUrl, setPrescriptionUrl] = useState(null);
  const [showPrescription, setShowPrescription] = useState(false);

  // const openPrescription = (url) => {
  //   setPrescriptionUrl(`${BASE_URL_IMG}${url}`);
  //   setShowPrescription(true);
  // };

  // const closePrescription = () => {
  //   setShowPrescription(false);
  //   setPrescriptionUrl(null);
  // };

  const [column, setColumn] = useState([
    {
      name: "Requested By",
      selector: (row) => row?.name,
      sortable: true,
    },
    {
      name: "Medicine Name",
      selector: (row) => row?.medicine_name,
    },
    {
      name: "Strength",
      selector: (row) => row?.strength,
    },
    {
      name: "Date",
      selector: (row) => row?.date,
    },
    {
      name: "Action",
      cell: (row) => (
        <Button
          size="sm"
          color="primary"
          onClick={() => handleView(row)}
        >
          Approve
        </Button>
      ),
    },
  ]);


  useEffect(() => {
    const body = {}
    getMedicineRequestList(body);
  }, []);
  const getMedicineRequestList = (body) => {
    setValue("isLoading", true)
    getMedicineRequest(body)
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {

          // toast.success(res.data.message);


          toast.clearWaitingQueue();
          setData(res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setData([]);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };


  const handleConfirmClick = () => {
    if (onConfirm) {
      onConfirm(selectedRow);
    }

    navigate("/medicine/add-medicine", {
      state: {
        medicine_name: selectedRow?.medicine_name,
        strength: selectedRow?.strength,
        id: selectedRow?.id,
        mode: "Add",
      fromRequest: true, 

      },
    });
  };




  return (
    <>
      <Head title={"Medicine | Medicine"} />
      <Content>
        <BlockHead size={`sm`} className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Medicine Request"}
              </BlockTitle>
            </BlockHeadContent>

          </BlockBetween>
        </BlockHead>
        <Block className="pt-0">

          <MyDataTable data={data || []} columns={column} title={"Medicine Request List"} isLoading={isLoading} />
        </Block>
      </Content>

      <Modal
        isOpen={viewModal}
        toggle={() => setViewModal(false)}
        size="lg"
        centered
      >
        <ModalHeader toggle={() => setViewModal(false)}>
          Medicine Details
        </ModalHeader>

        <ModalBody>
          Are you sure you want to{" "}
          {isPub ? (
            <>
              <Badge color={`${data?.isPublish ? "outline-warning" : "outline-success"}`}>
                {data?.isPublish ? "Archive " : "Publish "}
              </Badge>
            </>
          ) : (
            <span
              className={
                status == "Confirm" || status === true ? `text-primary text-capitalize` : `text-success text-capitalize`
              }
            >
              {status == "Confirm" || status === true ? "Cancel " : "Confirm "}
            </span>
          )}
          this?
        </ModalBody>

        <ModalFooter>
          <Button color="danger" onClick={() => setViewModal(false)}>
            Cancel
          </Button>

          <Button color="primary" onClick={handleConfirmClick}>
            Yes, Confirm
          </Button>

        </ModalFooter>


      </Modal>


    </>
  );
};

export default RequestMedicine;
